var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFiltericon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4353 1.02157C8.82265 0.617808 5.17626 0.617808 1.56362 1.02157C1.35951 1.04427 1.16526 1.12149 1.00127 1.24512C0.837286 1.36876 0.709598 1.53425 0.631608 1.72424C0.553619 1.91423 0.528203 2.1217 0.558029 2.3249C0.587855 2.52809 0.671822 2.71951 0.801119 2.87907L3.94195 6.76158C4.84167 7.8738 5.33261 9.26101 5.33279 10.6916V13.3099C5.33272 13.4081 5.35576 13.5049 5.40007 13.5925C5.44437 13.68 5.50868 13.756 5.58779 13.8141L7.89695 15.5074C7.969 15.5602 8.05428 15.5921 8.14332 15.5994C8.23236 15.6067 8.32168 15.5891 8.40136 15.5487C8.48105 15.5083 8.54797 15.4466 8.59471 15.3705C8.64145 15.2944 8.66617 15.2067 8.66612 15.1174V10.6916C8.66634 9.26062 9.15759 7.87307 10.0578 6.76074L13.1978 2.87741C13.3269 2.71784 13.4106 2.52649 13.4403 2.32342C13.47 2.12034 13.4446 1.91302 13.3666 1.72317C13.2886 1.53332 13.161 1.36794 12.9972 1.24435C12.8333 1.12077 12.6393 1.04437 12.4353 1.02157Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFiltericon);
export default __webpack_public_path__ + "static/media/filtericon.d0f80556fb45d1d2853df20c545b7580.svg";
export { ForwardRef as ReactComponent };